import * as React from "react";
import Button from "@sproutsocial/seeds-react-button";
import Text from "@sproutsocial/seeds-react-text";
import Icon from "@sproutsocial/seeds-react-icon";
import type { TypePeekInHeaderProps } from "../PeekInTypes";

/**
 * Header for PeekIn's main column.
 *
 * Layout comes from the seeds-peek-in-* classes in peek-in.css rather than
 * styled-system props on Box, so the header is Box-free on both render paths
 * and the desktop header row matches how PeekInTailwind lays out the mobile
 * bottom-sheet header. The title, subtitle, and back button still come from
 * the composed Seeds primitives, which own their own styling.
 */
export const PeekInHeader: React.FC<TypePeekInHeaderProps> = ({
  title,
  subtitle,
  onBack,
  children,
}) => {
  return (
    <div
      className="seeds-peek-in-header"
      data-slot="peek-in-header"
      data-qa-peek-in-header
    >
      <div className="seeds-peek-in-titlegroup">
        {onBack && (
          <Button
            appearance="unstyled"
            onClick={onBack}
            ariaLabel="Back"
            data-qa-peek-in-back
          >
            <Icon name="arrow-left-outline" size="small" />
          </Button>
        )}
        <div className="seeds-peek-in-titlestack">
          <Text.SubHeadline as="h2" data-qa-peek-in-title>
            {title}
          </Text.SubHeadline>
          {subtitle && (
            <Text.SmallBodyCopy
              as="div"
              color="text.body"
              data-qa-peek-in-subtitle
            >
              {subtitle}
            </Text.SmallBodyCopy>
          )}
        </div>
      </div>
      {children && (
        <div className="seeds-peek-in-header-actions">{children}</div>
      )}
    </div>
  );
};

PeekInHeader.displayName = "PeekInHeader";
